// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getShipViaRates, ShipViaRateResult } from "@guestsupply/App/Services/ShipViaRateService";
import { Dictionary } from "@insite/client-framework/Common/Types";
import { ApiHandler, createHandlerChainRunner, HasOnSuccess } from "@insite/client-framework/HandlerCreator";

export interface ShipViaParameter {
    shipViaIds: string[];
}

interface ShipViaProps {
    errorMessage: "";
}

type HandlerType = ApiHandler<ShipViaParameter & HasOnSuccess<Dictionary<string>>, ShipViaRateResult[], ShipViaProps>;

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getShipViaRates({ shipViaIds: props.parameter.shipViaIds });
    } catch (error) {
        props.errorMessage = error.message;
    }
};

export const ExecuteOnSuccess: HandlerType = props => {
    if (props.errorMessage) {
        return;
    }
    const result: Dictionary<string> = props.apiResult.reduce<Dictionary<string>>((acc, curr) => {
        acc[curr.shipViaId] = curr.shippingRate;
        return acc;
    }, {});

    props.parameter.onSuccess?.(result);
};

export const chain = [RequestDataFromApi, ExecuteOnSuccess];

const loadShippingRates = createHandlerChainRunner(chain, "loadShippingRates");

export default loadShippingRates;
